import { localizedText } from '../../common-js/LanguageMap';

export default function (DrawpService) {
    return {
        restrict: 'E',
        scope: {
            isOpen: '=',
            message: '=',
        },
        link: (scope, element) => {
            scope.localizedText = localizedText;
            let mdcDialog = null;

            const initDialog = () => {
                const dialogEl = element[0].querySelector('.mdc-dialog');
                if (dialogEl) {
                    mdcDialog = mdc.dialog.MDCDialog.attachTo(dialogEl);
                    mdcDialog.listen('MDCDialog:closed', () => {
                        scope.isOpen = false;
                        scope.$apply();
                    });
                }
            };

            scope.$watch('isOpen', (newVal) => {
                if (newVal) {
                    if (!mdcDialog) {
                        initDialog();
                    }
                    if (mdcDialog) {
                        mdcDialog.open();
                    }
                } else {
                    if (mdcDialog && mdcDialog.isOpen) {
                        mdcDialog.close();
                    }
                }
            });

            scope.goToLogin = () => {
                if (mdcDialog) {
                    mdcDialog.close();
                }
                DrawpService.openLoginDialog();
            };
        },
        template: `<div class="mdc-dialog">
            <div class="mdc-dialog__container">
                <div class="mdc-dialog__surface" role="alertdialog" aria-modal="true" aria-labelledby="my-dialog-title"
                    aria-describedby="my-dialog-content">
                    <div class="mdc-dialog__content" id="my-dialog-content">
                        {{ message }}
                    </div>
                    <div class="mdc-dialog__actions">
                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="cancel">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label">{{localizedText('CANCEL')}}</span>
                        </button>
                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="accept"
                            data-mdc-dialog-initial-focus ng-click="goToLogin()">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label">Log In</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="mdc-dialog__scrim"></div>
        </div>`
    };
}
